'use client'

import React, { useEffect } from 'react'

declare global {
    interface Window {
        _taboola: any
    }
}

interface Props {
    placement: string
}

export const Taboola: React.FC<Props> = ({ placement }) => {
    useEffect(() => {
        // Clean previous content
        const container = document.getElementById('taboola-thumbnails')
        if (container) {
            container.innerHTML = ''
        }

        // Ensure _taboola array exists
        window._taboola = window._taboola || []
        window._taboola.push({ article: 'auto' })

        // Load the Taboola script only once
        if (!document.getElementById('tb_loader_script')) {
            const script = document.createElement('script')
            script.id = 'tb_loader_script'
            script.src = '//cdn.taboola.com/libtrc/duplex-quartz/loader.js'
            script.async = true
            const firstScript = document.getElementsByTagName('script')[0]
            firstScript?.parentNode?.insertBefore(script, firstScript)
        }

        // If script already loaded, just reinitialize the widget
        window._taboola.push({
            mode: 'alternating-thumbnails-a',
            container: 'taboola-thumbnails',
            placement,
            target_type: 'mix',
        })
        window._taboola.push({ flush: true })

        if (window.performance?.mark) {
            window.performance.mark('tbl_ic')
        }
    }, [placement])

    return (
        <div className='mt-4'>
            <div id='taboola-thumbnails' />
        </div>
    )
}
